module.exports = __webpack_public_path__ + "static/media/curtain.a60e7a0b.png";